export default "__VITE_ASSET__CpzYZE3j__"